import { ref } from 'vue';

const errorMessage = ref<string | null>(null);

export const useErrorMessage = () => ({
    setErrorMessage: (value: string | null) => {
        errorMessage.value = value;
    },
    errorMessage: errorMessage.value,
});
